module.exports = __webpack_public_path__ + "static/media/Implant.fe2bb44e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/LandingPage/img/Implant.jpg
// module id = 1565
// module chunks = 0